import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, withModifiers as _withModifiers, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "p-d-flex p-jc-between p-flex-column p-flex-sm-row" }
const _hoisted_3 = { class: "toolbar_left" }
const _hoisted_4 = { class: "p-field p-mb-0 p-fluid" }
const _hoisted_5 = { class: "p-float-label p-input-icon-left" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_7 = {
  for: "search",
  class: "filled"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('material.list.title')), 1),
      _createVNode(_component_router_link, { to: _ctx.newRoute }, {
        default: _withCtx(() => [
          _createVNode(_component_Button, {
            icon: "pi pi-plus",
            label: "New"
          })
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createVNode(_component_DataTable, {
      filterDisplay: "menu",
      filters: _ctx.filters,
      "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters = $event)),
      value: _ctx.dataset,
      rows: 10,
      "rows-per-page-options": [10, 20, 50, 100],
      loading: _ctx.requestPending,
      paginator: true,
      "auto-layout": true,
      "striped-rows": true,
      globalFilterFields: ['name', 'note'],
      onRowClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToDetail($event.data)))
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              type: "button",
              label: "Refresh",
              icon: "pi pi-refresh",
              class: "p-button-outlined",
              onClick: _ctx.refresh
            }, null, 8, ["onClick"]),
            _renderSlot(_ctx.$slots, "toolbarLeft")
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_InputText, {
                  id: "search",
                  modelValue: _ctx.filters.global.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.filters.global.value = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('table.search_placeholder')), 1)
              ])
            ])
          ], 32)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "name",
          header: _ctx.$t('material.table.name'),
          sortable: true,
          showFilterMatchModes: false
        }, {
          filter: _withCtx(({filterModel, filterCallback}) => [
            _createVNode(_component_InputText, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              placeholder: "Search by name",
              onKeyup: _withKeys(filterCallback, ["enter"])
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "note",
          header: _ctx.$t('material.table.notes')
        }, null, 8, ["header"]),
        _createVNode(_component_Column, {
          header: "Actions",
          class: "column-header-right p-text-right",
          style: {"min-width":"100px","width":"100px"}
        }, {
          body: _withCtx(({data}) => [
            _withDirectives(_createVNode(_component_Button, {
              class: "p-button-warning p-mr-1",
              icon: "pi pi-pencil",
              onClick: _withModifiers(($event: any) => (_ctx.goToDetail(data)), ["stop"])
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                _ctx.$t('edit'),
                void 0,
                { bottom: true }
              ]
            ]),
            (_ctx.imAdmin)
              ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "p-button-danger",
                  icon: "pi pi-trash",
                  onClick: _withModifiers(($event: any) => (_ctx.onDelete(data)), ["stop"])
                }, null, 8, ["onClick"])), [
                  [
                    _directive_tooltip,
                    _ctx.$t('delete'),
                    void 0,
                    { bottom: true }
                  ]
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 3
    }, 8, ["filters", "value", "loading"])
  ]))
}